import React, { useState } from "react";
import { usePostHog } from 'posthog-js/react';
import { captureEvent } from "../utils/posthogUtils";
import { POSTHOG_EVENTS } from "../constants/posthog-events";

const ChangePasswordModal = ({ open, onClose, onSave }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const posthog = usePostHog();

  if (!open) return null;

  const handleSave = () => {
    setError("");
    if (!oldPassword || !newPassword || !confirmPassword) {
      captureEvent(posthog, POSTHOG_EVENTS.PASSWORD_VALIDATION_ERROR, { reason: 'missing_fields' });
      setError("All fields are required.");
      return;
    }
    if (newPassword !== confirmPassword) {
      captureEvent(posthog, POSTHOG_EVENTS.PASSWORD_VALIDATION_ERROR, { reason: 'passwords_dont_match' });
      setError("New password and confirm password do not match.");
      return;
    }
    onSave({ oldPassword, newPassword, confirmPassword });
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(4px)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 24,
          boxShadow:
            "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.05)",
          padding: 0,
          minWidth: 340,
          maxWidth: 380,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg, #6c757d 0%, #868e96 100%)",
            padding: "32px 32px 24px 32px",
            color: "white",
            textAlign: "center",
            position: "relative",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontWeight: 700,
              fontSize: "1.5rem",
              letterSpacing: "0.02em",
              textShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            Change Password
          </h2>
        </div>
        <div
          style={{
            padding: "32px",
            background: "#fafbfc",
            display: "flex",
            flexDirection: "column",
            gap: 18,
          }}
        >
          {error && (
            <div style={{ color: "#6c757d", marginBottom: 8, fontWeight: 500 }}>
              {error}
            </div>
          )}
          <label style={{ fontWeight: 500, marginBottom: 4 }}>
            Old Password
          </label>
          <input
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            style={{
              padding: "10px",
              borderRadius: 6,
              border: "1.5px solid #e0eafc",
              fontSize: 16,
            }}
          />
          <label style={{ fontWeight: 500, marginBottom: 4 }}>
            New Password
          </label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{
              padding: "10px",
              borderRadius: 6,
              border: "1.5px solid #e0eafc",
              fontSize: 16,
            }}
          />
          <label style={{ fontWeight: 500, marginBottom: 4 }}>
            Confirm Password
          </label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{
              padding: "10px",
              borderRadius: 6,
              border: "1.5px solid #e0eafc",
              fontSize: 16,
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 12,
              marginTop: 18,
            }}
          >
            <button
              onClick={onClose}
              style={{
                background: "#f3f0ff",
                color: "#6c757d",
                border: "none",
                borderRadius: 6,
                padding: "8px 18px",
                fontWeight: 600,
                fontSize: 16,
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              style={{
                background: "#6c757d",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                padding: "8px 18px",
                fontWeight: 600,
                fontSize: 16,
                cursor: "pointer",
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
